import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    canvasSizes: {
        'tab-0': [600, 450],
    },
}

export const canvasSizeSlice = createSlice({
    name: 'canvasSize',
    initialState,
    reducers: {
        setCanvasSize: (state, action) => {
            const { tabID, size } = action.payload;
            state.canvasSizes[tabID] = size;
        },
        removeCanvasSize: (state, action) => {
            delete state.canvasSizes[action.payload];
        },
        getCanvasSize: (state, action) => {
            return state.canvasSizes[action.payload];
        },
    }
})

export const { setCanvasSize, removeCanvasSize, getCanvasSize } = canvasSizeSlice.actions

export default canvasSizeSlice.reducer
